import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, RootState } from 'shared';
import Swal from 'sweetalert2';

interface IProps{
    length: number;
    url: string;
    isAsync?: boolean
}

export const useFileUploader = ({length, url, isAsync }: IProps) => {

    const dispatch = useDispatch<Dispatch>();
    const [documents, setDocuments] = useState<any>(null);
    const [originalNames, setOriginalNames] = useState<any[]>();
    const { response, loading } = useSelector(
        (state: RootState) => state.linkSupports
    );

    const handleChangeFile = (files: any) => {
      const arrayFiles = Array.from(files);
  
      if (files.length > length || response?.length + files.length > length) {
        return errorCantidadArchivos();
      }
  
      if (files.length > 0 && files[0].size > 0) {
        const formData = new FormData();
        arrayFiles.forEach((file:any)=> formData.append(`file`, file))
        const originalNames = arrayFiles.map((file:any) => {return {originalName: file.name}});
        setDocuments(formData);

        isAsync ? (
          dispatch.linkSupports.getLinkGlossesAsync({
            file: formData,
            url
          })
        ): (
          setOriginalNames(originalNames)
        )
      }
    };
  
    const removeFile = (doc: any) => {
      setDocuments(documents?.filter((x: any) => x.name !== doc.originalName));
      dispatch.linkSupports.filterLinkState(doc.id);
    };
  
    const errorCantidadArchivos = () => {
      Swal.fire({
        title: "Carga fallida",
        text: `El máximo de archivos permitidos es de ${length}`,
        icon: "error",
        timer: 5500,
      });
    };

    return {
        documents,
        response,
        loading,
        setDocuments,
        setOriginalNames,
        handleChangeFile,
        removeFile,
        originalNames
    }
}
